import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs/internal/operators/catchError";
import { IImagingUnit, ImagingUnit } from "../models/imagingUnit";
import { throwError } from "rxjs/internal/observable/throwError";

@Injectable({
  providedIn: 'root'
})
export class ImagingUnitService {
    myAppUrl = '';
    _data: any;

    constructor(public _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.myAppUrl = baseUrl;
    }

    getAllImagingUnits() {
        return this._http
            .get<IImagingUnit[]>(this.myAppUrl + 'api/ImagingUnit/GetAllImagingUnits')
            .pipe(catchError(this.handleError));
    }

    getAvailableUnits() {
        return this._http
            .get<ImagingUnit[]>(this.myAppUrl + 'api/ImagingUnit/GetAvailableUnits')
            .pipe(catchError(this.handleError));
    }

    getSampleSampleType(sampleId: any) {
        return this._http
            .get<number>(this.myAppUrl + 'api/LabSampleSelect/GetSampleSampleType?sampleId=' + sampleId)
            .pipe(catchError(this.handleError));
    }

    getBalenaCloudDomain() {
        return this._http
            .get('api/ImagingUnit/GetBalenaCloudDomain', { responseType: 'text' })
            .pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }
}
